/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { StyledDatePickerButton } from '#PRIVATE_StyledDatePickerButton';
import { UseYearCellProps, useYearCell } from './useYearCell';

type PickedUseYearCellProps = Pick<
  UseYearCellProps,
  'isCurrent' | 'isFocusable' | 'isFocused' | 'isSelected' | 'year' | 'onAction' | 'onNavigation'
>;
type Props = PickedUseYearCellProps;

/**
 * This component renders the individual year cell in the YearsGridView.
 */
export const YearCell = (props: Props) => {
  const { buttonProps } = useYearCell(props);
  return <StyledDatePickerButton {...buttonProps} />;
};
